export default "/static/assets/783e3b83ab95ba18.png"